import React, {useEffect, useRef, useState} from "react";
import CommonTitle from "../../components/common-title";
import {Coupon, CouponItem} from "../../components/coupon";
import {getOrdersAvailable, getOrdersDetail, postTradesSubmit, postTradesPayment, getTradesResult} from "../../service";
import {useHistory, useParams} from "react-router-dom";
import {Orders} from "../types";
import {priceConvert} from "../../units";
import useUserInfo from "../../routers/useUserInfo";
import usePagination from "../../routers/usePagination";
import Pagination from "../../components/pagination";
import InputRadio from "../../components/inputRadio";
import {useLoading} from "../../components/loading/LoadingProvider";
import {useModal} from "../../components/modal";
import {stringify} from "qs";

const classnames = require('classnames');

interface CouponModalProps {
    show: boolean,
    orderId: string,
    onclose: (data: CouponItem | boolean) => void
}

function getIsWxClient() {
    const ua = navigator.userAgent.toLowerCase();
    // @ts-ignore
    if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
        return true;
    }
    return false;
}


export const CouponModal: React.FC<CouponModalProps> = ({show, orderId, onclose}) => {

    const form = useRef(null)
    const [lists, setLists] = useState<Array<CouponItem>>([])
    const {pageRef, noMore, reset} = usePagination();
    const [pageNum, setPage] = useState<number>(1);
    const userData = useUserInfo()

    useEffect(() => {
        if (userData) {
            getOrdersAvailable({
                userId: userData.id,
                pageNum,
                orderId: orderId
            }).then(res => {
                const lists = res.data.list
                if ((lists as Array<CouponItem>).length > 0) {
                    setLists(list => list.concat(lists))
                } else {
                    noMore()
                }
            })
        }
    }, [pageNum])

    const confirm = () => {
        // @ts-ignore
        const r = lists.find((item) => item.id === form.current.elements.radio.value)
        // @ts-ignore
        if (r) {
            // @ts-ignore
            onclose(r)
        } else {
            onclose(false)
        }

    }


    return <div className={classnames('coupon-modal', {active: show})}>
        <div className="box">
            <div className="top">
                <h3>优惠券</h3>
                <p className="iconfont" onClick={() => onclose(false)}>&#xe611;</p>
            </div>
            <form ref={form}>
                <div className="coupon-lists">
                    {
                        lists.map((item, index) => {
                            return <Coupon {...item} key={index}>
                                <InputRadio value={item.id}/>
                            </Coupon>
                        })
                    }

                    <Pagination length={lists.length} ref={pageRef} onChange={(n) => setPage(n)}/>
                </div>

            </form>
            <div className="shadow">
                <div className="btn" onClick={confirm}>确认</div>
            </div>
        </div>
    </div>
}

export function calcPrice(t: any, r: any) {
    const _t = Number(t), _r = Number(r);
    if (isNaN(_t) || isNaN(_r)) {
        return 0
    }
    if (_t - _r < 0) {
        return 0
    }

    return priceConvert(_t - _r)
}


function DoPay() {

    const [modalShow, setShow] = useState(false)

    const [coupon, setCoupon] = useState<CouponItem | null>(null)

    const { id } = useParams<{ id: string}>()

    const [summary, setSummary] = useState<Orders>()
    const modal = useModal()
    const userDta = useUserInfo(false)
    const loading = useLoading()
    const {goBack, push,replace} = useHistory()

    const modalHandle = (data: CouponItem | boolean) => {
        if (typeof data !== 'boolean') {
            setCoupon(data)
        }
        setShow(false)
    }


    useEffect(() => {
        loading.showLoading()
        if(userDta && id){
            getOrdersDetail({
                orderId:id,
                userId:userDta.id
            }).then(res => {
                loading.hideLoading()
                if(res.code === 1){
                    setSummary(res.data)
                }else{
                    loading.showError('无法获取订单信息',() => {
                        goBack()
                    })
                }
            })
        }
    },[id])


    const doPayHandle = () => {

        if (summary && userDta) {
            loading.showLoading('支付中')
            postTradesSubmit({
                userId: userDta?.id,
                orderId: id,
                couponId: coupon?.id
            }).then(res => {
                loading.hideLoading()
                if (res.code === 1) {
                    if (res.data.payType === 2) {
                        const url = res.data.mwebUrl + `&redirect_url=${encodeURIComponent('http://www.tibavip.com/wx' + '?userId='+ userDta.id +'&tradeId=' + res.data.id)}`

                        if (!getIsWxClient()) {
                            window.location.href = url
                        } else {

                            replace(`/doWxPay?${stringify({
                                url,
                            })}`)

                        }
                    } else {
                        postTradesPayment({
                            tradeId: res.data.id,
                            userId: userDta.id
                        }).then(res => {
                            if (res.code === 1) {
                                loading.showSuccess('支付成功', () => {
                                    goBack()
                                })
                            }else{
                                modal.show({
                                    content:res.msg,
                                    showCancel:false,
                                    success(){
                                        goBack()
                                    }
                                })
                            }
                        })
                    }
                }
            })
        }
    }

    return <>
        <div className="doPay">
            <div className="top">
                <div className="img-box" style={{backgroundImage: `url(${summary?.coverUrl})`}}/>
                <div className="text">
                    <h3>{summary?.courseName}</h3>
                    <p className="price">价格：￥{priceConvert(summary?.totalFee)}</p>
                </div>
            </div>

            <div className="choose-coupon" onClick={() => setShow(true)}>
                <div className='common-input-box'>
                    <div className="common-input-item">
                        <div className="_left">
                            <p className="name"><span className="iconfont">&#xe607;</span> 卡券</p>
                            <p className="placeholder">{coupon?.couponName || "选择优惠券"}</p>
                        </div>
                        <div className="_right">
                            <p className="iconfont">&#xe608;</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="box">
                <CommonTitle title={'注意事项'}/>
                <div className="tip-lists">
                    {/*<p className="item">1. 学籍有效期至于 2021年07月8日 </p>*/}
                    <p className="item">1. 请在课程有效期内使用。</p>
                    <p className="item">2. 课程安排解释权归TIBA荷兰国际管家学院所有。</p>
                    <p className="item">3. 本课程为虚拟服务，暂不支持退款，如有疑问可电话咨询客服。</p>
                </div>
            </div>

            <div className="pay-box">
                <ul>
                    <li>
                        <p className="t">支付金额</p>
                        <p className="v">￥{priceConvert(summary?.totalFee)}</p>
                    </li>
                    <li>
                        <p className="t">优惠券</p>
                        <p className="v">{coupon ? `-￥ ${priceConvert(coupon.couponAmount)}` : '未使用优惠券'}</p>
                    </li>
                </ul>

                {
                    summary &&
                    <div className="common-btn"
                         onClick={doPayHandle}>确认支付 {calcPrice(summary.totalFee, coupon?.couponAmount || 0)}元</div>
                }

            </div>
        </div>
        {
            summary && <CouponModal orderId={summary.id} onclose={(data) => modalHandle(data)} show={modalShow}/>
        }

    </>
}

export default DoPay;
